export const getUserLocation = (): any => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        // eslint-disable-next-line
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
            );
            const data = await response.json();
            const currentCountryCode = data?.address?.country_code;
            const currentCountryName = data?.address?.country;
            const currentState = data?.address?.state;
            const currentCity = data?.address?.city;
            resolve({ currentCountryCode, currentCountryName, currentState, currentCity });
          } catch (error) {
            reject(error);
          }
        },
        (error) => {
          reject(error);
        }
      );
    } else {
      reject(new Error('Geolocation is not supported by this browser.'));
    }
  });
};
